import Content from '@layout/Content'
import FoundationForm from './FoundationForm'
import FoundationResult from './FoundationResult'
import { FoundationProvider } from './context'

function FoundationPage () {
  return (
    <FoundationProvider>
      <Content
        renderInput={<FoundationForm />}
        renderOutput={<FoundationResult />}
      />
    </FoundationProvider>
  )
}

export default FoundationPage
